<vass-header/>
<div class="content">
	<router-outlet/>
</div>
<vass-loading/>
